import api from "../../services/api";

const APIS = {
  GET_REQUESTS: "/CustomerRequests",
  TOGGLE_REQUEST: "/CustomerRequests"
};

export const getCustomerRequests = async (pageNumber = 1, pageSize = 10, filterText = '') => {
  try {
    const url = filterText?.trim()
      ? `${APIS.GET_REQUESTS}?PageNumber=${pageNumber}&PageSize=${pageSize}&FilterText=${encodeURIComponent(filterText.trim())}`
      : `${APIS.GET_REQUESTS}?PageNumber=${pageNumber}&PageSize=${pageSize}`;

    const response = await api.get(url);
    return response.data;
  } catch (error) {
    if (error.response?.data?.errors) {
      console.error("Validation errors:", error.response.data.errors);
    }
    console.error("Error fetching customer requests:", error);
    throw error;
  }
};

export const toggleRequestStatus = async (requestId, isUserRegistration = false) => {
  try {
    const response = await api.put(`${APIS.TOGGLE_REQUEST}?requestId=${requestId}&isUserRegistration=${isUserRegistration}`);
    return response.data;
  } catch (error) {
    console.error("Error toggling request status:", error);
    throw error;
  }
};
